import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SqlConsolePage } from "@/features/admin/sql-console-page";
import { ensureAdminAccess } from "@/lib/route-guards";

// F4 (D77): wybór bazy polem „Baza” w nagłówku. Brak `db` = Target (moduł jak przed F4);
// `db=apteka&idfirm=310122` = konsola ERP apteki, `db=source` = Source tylko do odczytu
// (D89/D2). `scope` przechodzi z karty apteki do tras agent-sync (backend sprawdza
// aptekę w zakresie i widoczności).
const searchSchema = z.object({
	db: z.enum(["target", "apteka", "source"]).optional().catch(undefined),
	idfirm: z.coerce.number().int().positive().optional().catch(undefined),
	scope: z.string().optional().catch(undefined),
	// Zlecenie do otwarcia w zakładce „Wyniki” (link ze strony Zatwierdzenia SQL); konsola zdejmuje je z URL.
	request: z.coerce.number().int().positive().optional().catch(undefined),
	// Adres panelu, z którego przyszedł skrypt — „Wróć do kontroli” (tylko /synchronizacja/…).
	wroc: z.string().optional().catch(undefined),
});

export type SqlConsoleSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/konfiguracja/sql-konsola")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: SqlConsolePage,
	validateSearch: (search: Record<string, unknown>): SqlConsoleSearch => searchSchema.parse(search),
});
